exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".textAreaMarkups{text-align:justify;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/evaluations/text_area_markups.scss
// module id = 1486
// module chunks = 0